module.exports = __webpack_public_path__ + "static/img/sigaeva.9deaa54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sigaeva.jpg
// module id = 189
// module chunks = 1